// ============================================================================
// LINGALA TRANSLATIONS - UNITY MODULE
// ============================================================================

export const unityTranslations = {
title: "Bomoko",
    author: "Na Emmanuel",
    subtitle: "Na ngambo ya bandelo, na nzela ya bomoko",
    description: "Makanisi na likoló ya bomoko kati na ba foi mpe bato",
    nav: {
      intro: "Introduction",
      religions: "Ba religions",
      common: "Ba valeurs communes",
      humility: "Komikitisa"
    },
    intro: {
      emmanuelSays: "Ngai Emmanuel, nalobi na bino:",
      ourBordersFromPast: "Bandelo na biso ewuti na tango ya kala",
      bordersDescription: "Ebotamaki wuta na bankama mibale ya histoire, bitumba, mpe ba héritages oyo epesami lokola ba timbres oyo ezali kosala biso tomona mokili na ba couleurs ndenge na ndenge.",
      divisionWork: "Kokabwana oyo ezali mosala ya Satana.",
      sharedHumanity: "Kasi humanité na biso ya commune ezali mozindo koleka ndelo nyonso – ezali eteni ya Nzambe kati na biso nyonso.",
      revelationTitle: "📖 Emoniseli:",
      surprisedLearning: "Nakamwaki mpe nayekolaki:",
      angelMichael: "Anzelu Michael azali na christianisme, islam mpe judaïsme.",
      jesusNames: "Yesu, Issa, Yeshua – ba nkombo ndenge na ndenge, moto moko.",
      diverseTribes: "Ba tribus ndenge na ndenge, Nzambe moko, ba nyoka ya temptation moko, mpe makomi etonda na bolingo.",
      sameRealities: "Ba réalités oyo ezali mpenza ndenge moko!",
      respectTitle: "🤝 Limemya:",
      respectFoundation: "Tosengeli komemya biso na biso – ezali miboko ya kimia mpe bomoi malamu elongo.",
      understandingProcess: "Bososoli ezali processus. Boyekoli emonisaki ngai ete makambo oyo nakanisaki ete ekeseni mingi ezali mpenza kolakisa esika moko.",
      whatBindsUs: "Oyo ezali kokanga biso",
      seekingRelation: "Biso nyonso tozali koluka boyokani na Mokeli, kosala na banzela ndenge na ndenge, na kati ya makomi ya ndenge na ndenge, kasi na ba points mystérieux moko pona kosimba ye.",
      loveOfGod: "Na lolenge moko, ezali likambo moko boye – bolingo ya Nzambe mpe mposa na biso ya kozwa ye.",
      universalLink: "Yango ezali lien universelle na biso.",
      inclusionTitle: "🌍 Inclusion:",
      vastInclusion: "Inclusion ya Nzambe ezali monene mingi.",
      respectDifferences: "Nandimi ete Nzambe azali komemya bokeseni na biso mpe andimi moto nyonso oyo azali kosala na bosembo mpe bolingo, ata soki bazali kolobela ye na ba nkombo to minoko ndenge na ndenge.",
      jesusCommand: "Yesu azali kotinda biso tolinga moninga, kozanga kotala na likolo na ye.",
      communitySpirit: "💭 Molimo ya communauté:",
      communityTerror: "Communauté ya somo ezali kobunda na oyo azali kosala mpe kolakisa kimia.",
      pridePolitics: "Lofundu na bango ezali politique, mpe bazali na mposa te ya komona humanité na biso ya commune.",
      prideQuotes: "Kasi makomi ezali kokebisa:",
      watchHeart: "Bátela motema na yo likolo ya nyonso, pamba te wuta na yango bomoi ebimaka.",
      refuseDivision: "Boyi kokota na bokabwani oyo.",
      freedomTitle: "🕊️ Bonsomi:",
      freedomOthers: "Bonsomi ya basusu ya kopona nzela na bango esengeli kobatelama.",
      defendFreedom: "Tosengeli kobatela bonsomi ya bato nyonso – na oyo bakanisi te lokola biso.",
      changeHeartTitle: "❤️ Mbongwana ya motema:",
      recognizeDecency: "Yeba bosembo mpe bwanya oyo ezali na kati ya tradition nyonso.",
      changeYourself: "Mbongwana ebandaka na yo. Pona komona malamu, ata soki ezali mpasi.",
      beExample: "Zala exemple, kozanga kozela eloko na bozongisi.",
      childrenPeaceTitle: "👶 Bana ya kimia:",
      avoidPursuit: "Zala mosika na oyo bazali kolanda koyina.",
      peaceChoice: "Kimia ezali kopona oyo osalaka mokolo nyonso.",
      discernTitle: "🔍 Discernement:",
      manSpeaks: "Moto alobi, kasi oyo ezali komonisa ye ezali misala na ye.",
      seeFruits: "Talá ba fruits – bazali kosala kimia to kobebisa?",
      lookPeaceTitle: "👀 Luka kimia:",
      lookPeaceAll: "Luka kimia bisika nyonso, kozanga kokesana.",
      godSpeaks: "Nzambe alobi na banzela ebele.",
      watchWordsTitle: "⚠️ Bátela maloba na yo:",
      watchShares: "Bátela oyo okaboli.",
      disqualify: "Kokata bato te na likolo ya ba peurs oyo batiaki na yo.",
      wisdomMaturityTitle: "🌱 Bwanya mpe maturité:",
      useScriptures: "Salela makomi pona komemya, kasi te pona kobebisa.",
      hateSin: "Koyina masumu ezali koloba te koyina moto.",
      separateActs: "Kabola misala na bomoto.",
      compassionNature: "Mawa ezali nature ya solo.",
      denounceLeadersTitle: "📢 Fungola ba leaders:",
      watchLeaders: "Bátela ba leaders oyo basaleli Nzambe pona kokabola mpe konyokola.",
      noJustice: "Bosembo ezali te esika oyo bolingo ezali te.",
      silenceComplicity: "Kovanda kimia ezali participation."
    },
    religions: {
      title: "Comparaison ya ba religions",
      intro: "Talá ndenge ba religions ya minene bazali komona ba concepts communes:",
      theirGod: "Nzambe na bango",
      theGood: "Malamu",
      theEvil: "Mabe",
      theAngels: "Ba anzelu",
      theUnity: "Bomoko",
      values: "Ba valeurs",
    commonGoal: "Ntina ya Lisángá",
    seekingPeace: "Mabondeli nyonso ezali na ntina moko: koluka kimya, kotombola bolingo mpé kotónga mokili ya malamu. Na nse ya bokeseni na biso, biso nyonso tozali lisángá na boluki oyo ya bwanya mpé boyokani.",
      christianity: {
        name: "Christianisme",
        godText: "Tata, Mwana (Yesu), Molimo Mosantu – misato na moko",
        goodText: "Kolanda Yesu, kolinga moninga lokola yo moko",
        evilText: "Satana, masumu, temptation",
        angelsText: "Michael, Gabriel – ba messagers ya Nzambe",
        unityText: "Losambo ya Yesu: 'Bázala moko lokola biso tozali moko'",
        values: "Bolingo, ngolu, kolimbisa, komikitisa, bondimi"
      },
      islam: {
        name: "Islam",
        godText: "Allah – moko mpe akabwani te",
        goodText: "Kotosa Allah, kozala sembo, kosala charité",
        evilText: "Iblis (Satana), ba désirs ya mabe",
        angelsText: "Jibril (Gabriel), Mikail – ba messagers ya boyengebene",
        unityText: "Ba musulmans nyonso bazali bandeko, Oumma moko",
        values: "Justice, mawa, komikitisa, boyengebene, losambo"
      },
      judaism: {
        name: "Judaïsme",
        godText: "YHWH – Nzambe ya Israël, moko mpe unique",
        goodText: "Kosalela mibeko, kolinga YHWH, kosala na bosembo",
        evilText: "Yetzer hara, temptation, masumu",
        angelsText: "Michael, Gabriel – ba messagers ya Nzambe",
        unityText: "Israël mobimba bazali na responsabilité ya bomoko, Shema Israël",
        values: "Torah, tsedaka, justice, éducation, communauté"
      },
      hinduism: {
        name: "Hindouisme",
        godText: "Brahman – réalité ultime, oyo emonisami na banzela ebele (devas/devis)",
        goodText: "Dharma (devoir sacré), ahimsa (kozanga violence)",
        evilText: "Maya (illusion), karma négatif",
        angelsText: "Devas (ba dieux/messagers ebele), nyonso manifestation ya Brahman",
        unityText: "'Vasudhaiva Kutumbakam' – Mokili mobimba ezali libota moko",
        values: "Ahimsa, dharma, karma, moksha (libération), méditation"
      },
      buddhism: {
        name: "Bouddhisme",
        godText: "Nzambe personnel te, kasi divinité universelle (Dharma, vérité)",
        goodText: "Kolanda Noble Sentier ya mwambe, mawa (karuna)",
        evilText: "Ignorance, désir, koyina – sources ya pasi",
        angelsText: "Bodhisattvas – ba êtres éveillés oyo basalisaka basusu",
        unityText: "Interconnexion ya ba êtres nyonso – makambo nyonso ezali moko",
        values: "Mawa, mindfulness, kozanga violence, patience, méditation"
      }
    },
    common: {
      title: "Ba valeurs communes",
      intro: "Ntango totali malamu, ba foi oyo nyonso ekabolaka ba concepts centraux:",
      goodTitle: "Malamu",
      goodDescription: "Ba religions nyonso epesaka motuya na justice, bolingo, mawa, komikitisa, mpe service pona basusu.",
      goodExamples: "• Kolinga moninga (christianisme)\n• Kosala na justice (islam)\n• Kosalela mibeko (judaïsme)\n• Dharma mpe ahimsa (hindouisme)\n• Mawa mpe mindfulness (bouddhisme)",
      evilTitle: "Mabe",
      evilDescription: "Ba foi nyonso eyebi ba forces oyo ezali komeka kobenda biso na malamu.",
      evilExamples: "• Satana/Iblis (christianisme/islam)\n• Yetzer hara (judaïsme)\n• Maya (illusion) mpe karma négatif (hindouisme)\n• Ignorance mpe désir (bouddhisme)",
      angelsTitle: "Ba anzelu",
      angelsDescription: "Ba messagers to ba intermédiaires spirituels kati na divinité mpe bato.",
      angelsExamples: "• Michael, Gabriel (christianisme, islam, judaïsme)\n• Devas (hindouisme)\n• Bodhisattvas (bouddhisme)",
      godTitle: "Nzambe",
      godDescription: "Ba traditions nyonso ezali kolakisa réalité ultime – ata soki babengaka yango na ba nkombo ndenge na ndenge.",
      godExamples: "• Tata, Mwana, Molimo Mosantu (christianisme)\n• Allah (islam)\n• YHWH (judaïsme)\n• Brahman (hindouisme)\n• Dharma/vérité (bouddhisme)",
      relationTitle: "Boyokani",
      relationDescription: "Biso nyonso tozali koluka connexion na Mosantu, kofanda na harmonie na vérité.",
      relationExamples: "• Kolanda Yesu (christianisme)\n• Kotosa Allah (islam)\n• Kosalela mibeko (judaïsme)\n• Kozwa moksha (hindouisme)\n• Kokoma na nirvana (bouddhisme)",
      inclusionTitle: "Inclusion",
      inclusionDescription: "Ba religions nyonso ezali kobanga bomoko, communauté, mpe limemya ya bokeseni.",
      inclusionExamples: "• 'Bázala moko' (christianisme)\n• 'Oumma moko' (islam)\n• 'Israël bakaba bango' (judaïsme)\n• 'Mokili libota moko' (hindouisme)\n• 'Interconnexion ya nyonso' (bouddhisme)",
      finalQuote: "Bandelo ezali na makanisi na biso.",
      finalQuote2: "Bomoko ezali na mitema na biso.",
      quoteAuthor: "- Emmanuel"
    },
    humility: {
      title: "7 ba étapes ya komikitisa",
      intro: "Solo ezwami na komikitisa. Talá ba étapes sambo pona mobembo oyo:",
      step: "Étape",
      action: "Action",
      step1Title: "Yeba ba limites na yo",
      step1Description: "Toyebi nyonso te, mpe ezali malamu.",
      step1Action: "Ndima ete bososoli na yo ezali parfait te. Kanisa te ete oyebi koleka moto mosusu.",
      step2Title: "Yoka basusu",
      step2Description: "Moto nyonso amemi eteni ya solo.",
      step2Action: "Yoka malamu liboso ya kozongisa. Tika basusu baloba kozanga kopekisa.",
      step3Title: "Ndima mabunga na yo",
      step3Description: "Mabunga ezali eteni ya koyekola.",
      step3Action: "Soki osali libunga, ndima. Senga bolimbisi, bongisa, mpe yekola.",
      step4Title: "Luka malamu na basusu",
      step4Description: "Na moto nyonso ezali likambo malamu, ata soki ezali mpasi ya komona.",
      step4Action: "Tyá makanisi na ba qualités ya malamu ya basusu na esika ya kofunda.",
      step5Title: "Longwa na lofundu",
      step5Description: "Lofundu ezali monguna ya bomoko.",
      step5Action: "Bátela makanisi ya lofundu – 'nazali malamu koleka bango' – mpe bwaka yango.",
      step6Title: "Salela na komikitisa",
      step6Description: "Bolingo ya solo esalelaka kozanga kozela eloko na bozongisi.",
      step6Action: "Sala makambo malamu na kimia, kozanga koluka lokumu to attention.",
      step7Title: "Sambela bwanya",
      step7Description: "Bwanya ya solo ewutaka na Nzambe, kasi na biso te.",
      step7Action: "Senga mokolo nyonso pona kososola solo malamu mpe kolinga malamu.",
      discernFruits: "🔍 Yeba ba fruits",
      humanHeart: "Motema ya moto ekoki kokosa, kasi misala na yango ezali komonisa solo na yango.",
      lookGodLove: "Luka bolingo ya Nzambe na moto nyonso, ata soki andimi ndenge mosusu.",
      watchOurWords: "Bátela maloba mpe misala na biso.",
      prideFruits: "Ba fruits ya lofundu: kokabwana, koyina, kobanga, contrôle, bitumba.",
      prideFruitsList: "Elimo ya etuka: \"Nazali na racio, point\"|Politiki ya lofundu: \"Nazali na racio ya kosala yo mabe\"|Kosalela ba écritures pona kosala mabe (processus ya mayele)|Koyina batu (kasi te kaka misala)|Ba chefs spirituels oyo babombaka dérive mpe lokuta na bango|Kovanda complice liboso ya injustice|Kokabwana mpe bitumba|Koyina oyo ebombami na piété|Moyibi mpe kobebisa|Manipulation pona lofundu|Kozanga bokebi mpe violence",
      
      godFruits: "Ba fruits ya Nzambe: bolingo, kimia, patience, mawa, bomoko.",
      godFruitsList: "Kokabola misala na moto na bwanya|Mawa pona bobola na biso ya bomoto|Grâce na kobatela biso na ba contextes|Koloba injustice pona kobatela basusu|Koloba solo na mpiko|Kimia pona bato nyonso|Bolingo kozanga kokesana|Boyokani mpe bomoko|Komikitisa mpe bokebi|Bonsomi pona bato nyonso",
      
      finalQuote: "Soki olingi komona elongi ya Nzambe, talá elongi ya moninga.",
      author: "- Emmanuel"
    },
    footer: {
      quote: "Bolingo elongaka ntango nyonso, mpe solo ekangaka biso.",
      author: "- Emmanuel"
    }
};

export default unityTranslations;
